<template>
  <div class="login-page" >
  	<div class="white-box">
  		<div class="left">
        <el-image
			class="logo"
              :src="url"
              ></el-image>
        <div class="title">好日子管理后台</div>
      </div>
      <div class="line"></div>
  		<div class="right">
  			<div class="form-box">
          <div class="form-item mb-30">
            <img src="../../assets/images/icon/icon-account.png" class="icon" />
            <input class="form-item" v-model="loginForm.username" size="large" placeholder="用户名"
              type='text' maxlength="11" autocomplete="off" />
          </div>
          <div class="form-item">
            <img src="../../assets/images/icon/icon-key.png" class="icon" />
            <input class="form-item" v-model="loginForm.password" size="large" placeholder="密码"
              type='password' maxlength="11" autocomplete="new-password" />
          </div>
  			</div>
        <button type="button" class="login-btn" @click.stop="onSubmit()">登录</button>
  		</div>
  	</div>
    <div class="foot">
      <p>Copyright 2021 - Now 风筝与云 <a href="http://beian.miit.gov.cn/" target="_blank" style='color: #E5B68F'>渝ICP备2022001417号</a>
      </p>
    </div>
  </div>
</template>

<script>
	import {
		loginByUsername
	} from '@/api/login'
	import Cookies from 'js-cookie'
	export default {
		name: 'login',
		data() {
			return {
				loginForm: { //登录表单字段
					username: '',//13111111111
					password: '',//123456
				},
				url:"/logo.ico"
			}
		},
		computed: {},
		beforeRouteUpdate() {},
		methods: {
			//校验
			validate() {
				// let reg = /^1[0-9][0-9]\d{8}$/;
				// if (!this.loginForm.username) {
				// 	this.$message.error('请输入手机号码');
				// 	return false;
				// }
				// if (!reg.test(this.loginForm.username)) {
				// 	this.$message.error('手机号输入错误');
				// 	return false;
				// }
				if (!this.loginForm.password) {
					this.$message.error('请输入密码');
					return false;
				}
				return true
			},
			//登录
			onSubmit: function() {
				let _this = this;
				let validateResult = _this.validate();
				if (validateResult) {
					_this.$throttle.canDoFunction({
						key: "onSubmit",
						time: 3000,
						success: () => {
							loginByUsername(_this.loginForm).then(res => {
								Cookies.set('token', res.data);
								_this.$router.push({
									name: 'telOrder'
								})
							})
						}
					});
				}
			},
		}
	}

</script>
<style lang="scss">
	input{
		background-color:transparent;
		border:0;
		outline: none;
	}
</style>

<style lang="scss" scoped>
 .login-page {
 		position: relative;
 		width: 100%;
 		min-width: 1200px;
 		height: 100vh;
 		background: #2B423E;
 		font-size: 30px;
    .foot{
      position: absolute;
      left: 30%;
      top: 90%;
      color: #E5B68F;
    }
 		.white-box {
 			position: absolute;
 			left: 50%;
 			top: 50%;
 			margin-left: -542px;
 			margin-top: -281px;
 			width: 1084px;
 			height: 563px;
       background-repeat: no-repeat;
       background-size: cover;
       background-position: center;
       background-image: url(../../assets/images/login_bg.png);
       display: flex;
       align-items: center;
 			.left {
         display: inline-block;
         box-sizing: border-box;
 				width: 425px;
 				height: 563px;
         padding-top: 150px;
         .logo {
           background-image: url(/logo.ico) ;
		   background-repeat:no-repeat;
           font-size: 37px;
           width: 130px;
           height: 130px;
           line-height: 130px;
           border-radius: 20px;
           // background: #E5B68F;
           margin: 0 auto 37px;
           text-align: center;
		   margin-left: 150px;
         }
         .title {
           font-size: 30px;
           color: #E5B68F;
           text-align: center;
         }
 			}
       .line{
         width: 1px;
         height: 350px;
         background: rgba(255, 255, 255, 0.1);
       }
 			.right {
 				display: inline-block;
 				width: 658px;
 				height: 563px;
 				padding-top: 104px;
 				box-sizing: border-box;
 				.form-box {
 					margin: 0 0 0 89px;
 					width: 375px;
           .mb-30{
             margin-bottom: 30px;
           }
           .form-item{
             border-bottom: 1px solid rgba(255, 255, 255, 0.3);
             display: flex;
             align-items: center;
             line-height: 80px;
						 height: 80px;
             padding: 0 14px;
             .icon {
               width: 27px;
               height: 27px;
               margin-right: 11px;
             }
             input{
               background: transparent;
               border: 0;
               font-size: 16px;
               color: rgba(255, 255, 255, 0.7);
             }
             input[type=text]:focus{ outline: 0;}
             ::-webkit-input-placeholder { /* WebKit browsers */
                 color: rgba(255, 255, 255, 0.4);
             }
             :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color: rgba(255, 255, 255, 0.4);
             }
             ::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: rgba(255, 255, 255, 0.4);
             }
             :-ms-input-placeholder { /* Internet Explorer 10+ */
                color: rgba(255, 255, 255, 0.4);
             }
           }

 				}
         .login-btn {
           width: 370px;
           height: 80px;
           line-height: 80px;
           background: #E5B68F;
           border-radius: 40px;
         	color: #425D58;
         	font-size: 30px;
         	letter-spacing: 4px;
         	font-weight: bold;
           cursor: pointer;
           border: 0;
           padding: 0;
           margin: 57px 0 0 90px;
           display: block;
         }
 			}
 		}
 	}
</style>
